import { SettingsManager } from "@viamap/viamap2-common";
import { fetchServitutProcessor } from "src/utils/servitutProcessorServiceHost";
import type { PlanitDocumentKind, PlanitElements, PlanitExtractResult, PlanitVariable } from "./PLALLMCheck";

export async function extractPlanitDocument(params: {
   kind: PlanitDocumentKind;
   file: File;
   variables: PlanitVariable[];
   elements: PlanitElements;
   signal?: AbortSignal;
   caller?: { userRef: string; userName: string; organizationId: string };
}): Promise<PlanitExtractResult> {
   const path = params.kind === "lokalplan" ? "/planit/extract-lokalplan" : "/planit/extract-arealskema";
   const formData = new FormData();
   formData.append("metadata", JSON.stringify({
      variables: params.variables,
      elements: params.elements,
   }));
   formData.append("file", params.file, params.file.name);

   const headers: Record<string, string> = {};
   const token = SettingsManager.getSystemSetting("jobs.jobServiceAPIKey");
   if (token) headers["access-token"] = token;
   if (params.caller) {
      headers["user-ref"] = params.caller.userRef;
      headers["user-name"] = params.caller.userName;
      headers["organization-id"] = params.caller.organizationId;
   }

   const response = await fetchServitutProcessor(path, {
      method: "POST",
      headers,
      body: formData,
      signal: params.signal,
   });

   const payload = await response.json().catch(() => ({}));
   if (!response.ok) {
      const detail = typeof payload?.detail === "string" ? payload.detail : response.statusText;
      throw new Error(detail || `LLM check failed (${response.status})`);
   }
   return payload as PlanitExtractResult;
}
